import request from '@/utils/request'

// 获取本周活动
export function getWeekActivities() {
  return request({
    url: '/front/activity/week',
    method: 'get'
  })
}

// 按日期获取活动
export function getActivitiesByDate(date) {
  return request({
    url: '/front/activity/byDate',
    method: 'get',
    params: { date }
  })
}

// 获取活动详情
export function getActivityDetail(activityId) {
  return request({
    url: '/front/activity/' + activityId,
    method: 'get'
  })
}
